import { unstableSetRender } from 'antd';
import { createRoot, type Root } from 'react-dom/client';

/**
 * AntD 5's static calls (Modal.confirm, message.success) render through
 * ReactDOM.render, which React 19 removed: without this they do nothing, with
 * no error (2 Nov 2026, Approve discount). This is AntD's documented React 19
 * hook, the same code as @ant-design/v5-patch-for-react-19. Import it before
 * anything renders. Deprecated only because AntD 6 supports React 19 itself;
 * delete this file when we move to it.
 */
// eslint-disable-next-line @typescript-eslint/no-deprecated -- see above
unstableSetRender((node, container) => {
  const host = container as Element & { _nksRoot?: Root };
  host._nksRoot ??= createRoot(host);
  const root = host._nksRoot;
  root.render(node);
  return async () => {
    await new Promise((done) => setTimeout(done, 0));
    root.unmount();
    delete host._nksRoot;
  };
});
